import { render, staticRenderFns } from "./distribution-detail.vue?vue&type=template&id=a0619194&scoped=true"
import script from "./distribution-detail.vue?vue&type=script&lang=js"
export * from "./distribution-detail.vue?vue&type=script&lang=js"
import style0 from "./distribution-detail.vue?vue&type=style&index=0&id=a0619194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0619194",
  null
  
)

export default component.exports